<template>
  <div
    class="flex flex-col items-center justify-center p-8 min-h-[200px] bg-gray-50 border border-gray-200 rounded-lg text-center"
  >
    <div class="mb-4">
      <AppIcon name="warning" :size="48" color="var(--color-energy-warning)" />
    </div>
    <h2 class="text-error-600 text-xl font-semibold m-0 mb-3">
      {{ STRINGS.ui.titles.componentError }}
    </h2>
    <p class="text-gray-600 text-base m-0 mb-6 max-w-[400px] leading-normal">{{ message }}</p>
    <button
      @click="handleRetry"
      class="bg-primary-500 text-white border-none py-3 px-6 rounded-lg text-base font-medium cursor-pointer transition-colors hover:bg-primary-600 focus:outline-2 focus:outline-primary-500 focus:outline-offset-2 active:bg-primary-700"
      type="button"
    >
      {{ STRINGS.ui.buttons.tryAgain }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { STRINGS } from '@/constants/strings';
import AppIcon from '@/components/ui/icons/AppIcon.vue';

interface Props {
  message?: string;
  onRetry?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  message: STRINGS.errors.component.defaultMessage,
});

const handleRetry = () => {
  if (props.onRetry) {
    props.onRetry();
  } else {
    // Default behavior: reload the page
    window.location.reload();
  }
};
</script>
